//
// File: main.ts
// Description: Main entry point for the shell application, imports css and boots the application
// CopyRight: Broadlume 2024
//

import './styles.css';

import {
  importWithChunkRetry,
  registerGlobalChunkLoadRecovery,
} from './app/shared/utils/chunkLoadRecovery';
import { initSentry } from './sentry';

initSentry();

registerGlobalChunkLoadRecovery();
importWithChunkRetry(() => import('./bootstrap'));
